import React from 'react';
import { Breadcrumb, Panel } from 'rsuite';
import ContinentList from './continent-list';
import PageHeader from '@/components/PageHeader';

const Page = () => {
  return (
    <Panel
      header={
        <PageHeader title='Continents'>
          <Breadcrumb>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
            <Breadcrumb.Item >Master Data</Breadcrumb.Item>
            <Breadcrumb.Item active>Continents</Breadcrumb.Item>
          </Breadcrumb>
        </PageHeader>
      }
    >
      <ContinentList />
    </Panel>
  );
};

export default Page;
